import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProfileScreen from './screens/ShareProfileScreen';
import OnboardingScreen  from './screens/onboardingScreens/Onboarding'
import Edit from './screens/ProfileEdit';
import Profile from './screens/ProfileScreen';
import Login from './screens/Login';

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/:username" element={<ProfileScreen />} />
      <Route path="/onboarding" element={<OnboardingScreen />} />
      <Route path="/login" element={<Login />} />
      <Route path="/edit/:username" element={<Edit />} />
      <Route path="/profile/:username" element={<Profile />} />
    </Routes>
  </Router>
);

export default AppRoutes;
